import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Row, Col } from 'reactstrap';
import domainModel from 'domain-model';
// import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import BlurableNumberInput from './BlurableNumberInput';

import ArticleQuantityInputLegacy from './ArticleQuantityInputLegacy';

import {
  recalculateIncreaseInput,
  recalculateDecreaseInput,
} from './articleQuantityInputCalculators';

function getDisplayUnit(article, orderedSKU, value) {
  if (orderedSKU && value !== 1) {
    return (
      domainModel.getPluralization(
        'article.stockKeepingUnits.names',
        orderedSKU?.name,
      ) ||
      orderedSKU.name || // Remove this when SKU is used is in shop
      (article.orderUnit === 'package'
        ? ' frp'
        : ` ${article.displayOrderableUnit}`)
    );
  }
  return (
    orderedSKU?.name || // Remove this when SKU is used is in shop
    (article.orderUnit === 'package'
      ? ' frp'
      : ` ${article.displayOrderableUnit}`)
  );
}
function ArticleQuantityInput(props) {
  const {
    name,
    value,
    article,
    cartRow,
    orderedSKU,
    possibleToSetAnyValue,
    disabled,
    onChange,
    wideClickable,
    isGothiaMode,
  } = props;

  if (!article) return <></>;
  // the sku can be passed directly as a prop, or it can be fetched from the cartRow
  const orderedSKUForUse = orderedSKU || cartRow?.orderedSKU;

  if (!orderedSKUForUse) {
    return <ArticleQuantityInputLegacy {...props} />;
  }

  const [isEditing, setIsEditing] = useState(false);

  const hidePlusMinus = disabled && isEditing;

  return (
    <>
      <Row
        className={`justify-content-between align-items-center g-0 ${
          disabled ? ' bg-light text-muted' : 'text-end bg-white'
        }`}
      >
        {value > 0 && (
          <>
            {!isEditing && (
              <Col className={`p-0 ${hidePlusMinus ? 'd-none' : ''}`} xs={3}>
                <Button
                  className="d-inline-block rounded-0 shadow-none w-100 subtractButton text-nowrap"
                  id={`subtractButton-${article.id}`}
                  color={value <= 0 ? 'muted' : 'secondary'}
                  size={isGothiaMode ? 'sm' : ''}
                  onClick={() => {
                    onChange(
                      name,
                      recalculateDecreaseInput(
                        value - (orderedSKUForUse.stepOrderIncrement || 1),
                        orderedSKUForUse,
                        possibleToSetAnyValue,
                      ),
                    );
                  }}
                  disabled={disabled || value <= 0}
                >
                  <strong>-{orderedSKUForUse.stepOrderIncrement || 1}</strong>
                </Button>
              </Col>
            )}
            <Col
              className={`text-center articleQuantityInput ${
                wideClickable ? 'd-flex' : ''
              } ${isGothiaMode ? 'py-0' : 'py-1'}`}
              xs={isEditing ? 12 : 6}
            >
              <BlurableNumberInput
                styles={isGothiaMode ? {} : { minHeight: '35px' }}
                className="d-inline-block"
                value={value}
                onChange={(propName, numberValue) => {
                  setIsEditing(false);
                  onChange(
                    name,
                    recalculateIncreaseInput(
                      numberValue,
                      orderedSKUForUse,
                      possibleToSetAnyValue,
                    ),
                  );
                }}
                name={name}
                disabled={disabled}
                step={0.01}
                onEditBegin={() => setIsEditing(true)}
                onEditEnd={() => setIsEditing(false)}
                wideClickable={wideClickable}
                isGothiaMode={isGothiaMode}
              >
                {value}{' '}
                {getDisplayUnit(
                  article,

                  orderedSKU,
                  value,
                )}
              </BlurableNumberInput>
            </Col>

            {!isEditing && (
              <Col className={`p-0 ${hidePlusMinus ? 'd-none' : ''}`} xs={3}>
                <Button
                  className="d-inline-block w-100 rounded-0 shadow-none addButton text-nowrap"
                  id={`addButton-${article.id}`}
                  color="primary"
                  size={isGothiaMode ? 'sm' : ''}
                  disabled={disabled}
                  onClick={async () => {
                    await onChange(
                      name,
                      recalculateIncreaseInput(
                        value + (orderedSKUForUse.stepOrderIncrement || 1),
                        orderedSKUForUse,
                        possibleToSetAnyValue,
                      ),
                    );
                  }}
                >
                  <strong>+{orderedSKUForUse.stepOrderIncrement || 1}</strong>
                </Button>
              </Col>
            )}
          </>
        )}
      </Row>
    </>
  );
}

ArticleQuantityInput.propTypes = {
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.number,
  article: PropTypes.object,
  disabled: PropTypes.bool,
  possibleToSetAnyValue: PropTypes.bool,
  showOrderUnitSelect: PropTypes.bool,
  cartRow: PropTypes.object,
  orderedSKU: PropTypes.object,
  shopConfig: PropTypes.object,
  wideClickable: PropTypes.bool,
  isGothiaMode: PropTypes.bool,
};

ArticleQuantityInput.defaultProps = {
  article: null,
  cartRow: null,
  name: null,
  disabled: false,
  showOrderUnitSelect: false,
  value: 0,
  possibleToSetAnyValue: false,
  orderedSKU: null,
  shopConfig: {},
  wideClickable: false,
  isGothiaMode: false,
};

export default ArticleQuantityInput;
